<template>
  <div class="modal-toast" :class="[param.type]">
    <div class="content-block row-block">
      <img :src="{
        success: require('../../assets/images/toast-alert-icon.svg'),
        error: require('../../assets/images/toast-error-icon.svg')
      }[param.type]">
      <div :style="{ width: '20px' }"></div>
      <div :style="{ flex: 1 }" class="content" :class="[param.type]" v-html="param.content"></div>
    </div>
    <div class="button-row">
      <button v-for="(button, index) in param.buttons || []" :key="index" :class="[button.type + '-button']" :style="button.style || {}" @click="$emit('changeModal', {}, button.result)">
        <span>{{ button.title }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/toast.vue